import { useState } from 'react';
import { imagePickSize } from 'utils/general';
import clsx from 'clsx';
import Avatar from 'components/Avatar';
import DropdownButton from 'components/Button/DropdownButton/DropdownButton';
import APResponsiveDropdown from 'components/Dropdown/APResponsiveDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.scss';

const MemberAssignment = ({ members, assignments, onAdd, onRemove }) => {
  const [showOrgMembers, toggleMemberDropdown] = useState(false);

  const show = () => {
    toggleMemberDropdown(true);
  };

  const dismiss = () => {
    toggleMemberDropdown(false);
  };

  const renderAssignmentMenu = () => {
    return (
      <>
        {members.map(member => {
          const isSelected = assignments.some(assignment => assignment.id === member.id);
          const profileImage = member.profile_image ?? null;
          let imagePath = null;
          if (profileImage) {
            imagePath = `//${process.env.REACT_APP_AWS_CLOUDFRONT}/${imagePickSize(
              profileImage,
              'square60',
            )}`;
          }

          return (
            <button
              key={`lead-assignment--${member.id}`}
              className={clsx(
                'ap-dropdown__button',
                'ap-dropdown__button--task-assignment',
                'button--unstyled',
                { 'selected': isSelected },
              )}
              onClick={() => onAdd(member)}
            >
              <div className="inline-avatar">
                <div className="inline-avatar__image">
                  <Avatar
                    photo={imagePath}
                    text={!imagePath ? member.initials : null}
                    size={30}
                    borderSize={1}
                  />
                </div>
                <div className="inline-avatar__info">
                  {member.firstname} {member.lastname}
                </div>
              </div>
            </button>
          );
        })}
      </>
    );
  };

  const trigger = (
    <DropdownButton className="button--unstyled button--assignment">
      Add
    </DropdownButton>
  );

  return (
    <>
      <div className="assigned-heading">Assigned</div>
      {assignments.length ? (
        <div className="assigned-list">
          {assignments.map(member => (
            <div
              key={member.id}
              className="assigned-item"
            >
              <Avatar
                photo={
                  member.profile_image
                    ? `//${process.env.REACT_APP_AWS_CLOUDFRONT}/${imagePickSize(member.profile_image, 'square60')}`
                    : null
                }
                text={!member.profile_image ? member.initials : null}
                size={30}
                borderSize={1}
              />
              <div className="assigned-item__name">
                {member.firstname} {member.lastname}
              </div>
              <div
                className="assigned-item__remove"
                onClick={() => onRemove(member)}
              >
                <FontAwesomeIcon
                  icon={['fal', 'times']}
                  size="xs"
                />
              </div>
            </div>
          ))}
        </div>
      ) : null}
      <APResponsiveDropdown
        opened={showOrgMembers}
        show={show}
        dismiss={dismiss}
        triggerButton={trigger}
        placement="bottom-end"
        menuClass="assignment-data-dropdown"
      >
        {renderAssignmentMenu()}
      </APResponsiveDropdown>
    </>
  );
};

export default MemberAssignment;
